<template>
  <div class="mail">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Mail'
}
</script>
